import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { DownloadHangtagPdf } from "@tSurya/Services/HangtagDownloadPdfService";
import { GetPreviewParameter } from "@tSurya/Services/HangtagPreviewService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";


type  DownloadPdfParameter = HasOnSuccess<BlobPart> & GetPreviewParameter & HasOnError;

type HandlerType = CustomApiHandler<DownloadPdfParameter, BlobPart>;

export const PopulateApiParameter: HandlerType = props=> {
    props.apiParameter = props.parameter;
}

export const RequestDataFromApi : HandlerType = async props =>{
    try{
        props.apiResult = (await DownloadHangtagPdf(props.apiParameter)) as unknown as BlobPart;

    }
    catch(error){
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
}

export const ExecuteOnSuccessCallback: HandlerType = props =>{
    if(props.apiResult){
        const blob = new Blob([props.apiResult], {type: "application/pdf"});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const fileName = `Hangtag_${now.getFullYear()}${now.getMonth() + 1}${now.getDate()}${now.getHours()}${now.getMinutes()}${now.getSeconds()}`;
        link.download = `${fileName}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);

        props.parameter.onSuccess?.(props.apiResult);
    }
}

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const DownloadPdf = createHandlerChainRunner(chain, "downloadPdf");
export default DownloadPdf;